export default "__VITE_ASSET__Dv0RkkiS__"